const $ = jQuery;
const ticking = false;

const header = document.querySelector("#mainHeader");

const waypoint = new Waypoint({
    element: header,
    handler: function (direction) {
        if (direction === "down") {
            const $stickyHeader = jQuery(header).clone(true);
            $stickyHeader.addClass("sticky");
            $stickyHeader.appendTo("body");

            gsap.fromTo($stickyHeader, { y: "-100%" }, { y: "0%", duration: 0.2 });
        } else {
            const stickyHeader = document.querySelector("#mainHeader.sticky");
            gsap.to(stickyHeader, {
                y: "-100%",
                duration: 0.2,
                onComplete: function () {
                    stickyHeader.remove();
                },
            });
        }
    },
    offset: -(header.clientHeight + 50),
});

const footerSlider = new Flickity(".main_footer__slider", {
    wrapAround: true,
    autoPlay: 3000,
    pageDots: false,
    prevNextButtons: false
});

jQuery(".mobile_toggle_button").on("click", function () {
    jQuery(this).toggleClass("active");

    if (jQuery(this).hasClass("active")) {
        // Open Drawer
        gsap.to(".menu_drawer", { x: 0, duration: 0.5, ease: CustomEase.create("custom", "0.075, 0.82, 0.165, 1") });
        gsap.fromTo(".menu_drawer__backdrop", { opacity: 0 }, { opacity: 1, display: 'block', duration: 0.5 });
        // Prevent body srcoll
        jQuery("body").addClass("scroll-disabled");
    } else {
        // Close Drawer
        gsap.to(".menu_drawer", {
            x: (_, target) => -target.clientWidth,
            duration: 0.5,
            ease: CustomEase.create("custom", "0.075, 0.82, 0.165, 1"),
        });
        gsap.fromTo(".menu_drawer__backdrop", { opacity: 1 }, { opacity: 0, display: 'none', duration: 0.5 });
        jQuery("body").removeClass("scroll-disabled");
    }
});

$(".mobile_menu span.menu-item-has-children").on("click", function(){
    if($(this).hasClass("open")) {
        gsap.to($(this).next(), {height: 0, duration: 0.3});
        $(this).removeClass("open");
    }else {
        gsap.to($(this).next(), {height: 'auto', duration: 0.3});
        $(this).addClass("open");
    }
});

$("span.current-menu-parent").addClass("open");